// extracted by mini-css-extract-plugin
export var container = "_56-0";
export var icon = "_56-1";
export var text = "_56-2";